import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { MilestoneCategoryState, MilestoneCategoryStore } from './milestone-category.store';

@Injectable({ providedIn: 'root' })
export class MilestoneCategoryQuery extends QueryEntity<MilestoneCategoryState> {
  protected store: MilestoneCategoryStore;

  constructor() {
    const store = inject(MilestoneCategoryStore);

    super(store);

    this.store = store;
  }
}
